interface PDFFileIconProps {
  variant?: 'primary' | 'secondary';
}

export const PDFFileIcon = ({ variant = 'primary' }: PDFFileIconProps) => {
  const bgColor = {
    primary: '#DB0202',
    secondary: '#AAAAAA'
  };

  const detailColor = {
    primary: '#F7B9B9',
    secondary: '#828282'
  };
  return (
    <div>
      <svg
        width="18"
        height="22"
        viewBox="0 0 18 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 22H2C0.89543 22 0 21.1046 0 20V2C0 0.89543 0.895431 0 2 0H13L18 5V20C18 21.1046 17.1046 22 16 22Z"
          fill={bgColor[variant]}
        />
        <path
          d="M13 4V0L18 5H14C13.4477 5 13 4.55228 13 4Z"
          fill={detailColor[variant]}
        />
        <path
          d="M4.3493 11H2V16H3.1005V14.3784H4.28686C5.46541 14.3784 6.25371 13.7477 6.25371 12.6592C6.25371 11.5856 5.57468 11 4.3493 11ZM5.1298 12.6817C5.12199 13.1697 4.77077 13.4324 4.1932 13.4324H3.1005V11.9384H4.1932C4.76296 11.9384 5.1376 12.1862 5.1298 12.6817Z"
          fill="white"
        />
        <path
          d="M8.99107 11H6.98519V16H8.95204C10.6067 16 11.6448 15.0315 11.6448 13.4775C11.6448 11.9234 10.6457 11 8.99107 11ZM8.90521 15.0616L8.09349 15.0541V11.9309H8.8818C9.90425 11.9384 10.4818 12.494 10.4818 13.515C10.4818 14.536 9.91205 15.0616 8.90521 15.0616Z"
          fill="white"
        />
        <path
          d="M16 11.976V11H12.4956V16H13.5961V14.1982H15.7971V13.2297H13.5961V11.976H16Z"
          fill="white"
        />
      </svg>
    </div>
  );
};
